/**
 * Provides a gui for uploading images in bulk.
 * @module images/upload-bulk
 */
import React, { Component } from 'react'
import pick from 'lodash/pick'
import { connect as connectRedux } from 'react-redux'
import { compose } from 'recompose'
import { bindActionCreators } from 'redux'
import Form from 'muicss/lib/react/form'
import Input from 'muicss/lib/react/input'
import Button from 'muicss/lib/react/button'
import { getAuthLogin as getAuthLoginAction } from '../../../services/auth/redux/actions'

/**
 * React component
 */
class LoginForm extends Component {
  constructor (props) {
    super(props)
    this.state = { username: '', password: '' }
  }

  setUsername = (event) => {
    const username = event.target.value
    this.setState(() => ({ username }))
  }

  setPassword = (event) => {
    const password = event.target.value
    this.setState(() => ({ password }))
  }

  onSubmit = (event) => {
    event.preventDefault()
    const { state, props } = this
    const { getAuthLogin } = props
    const { username, password } = state
    getAuthLogin({ username, password })
  }

  render () {
    const { props } = this
    const { auth, className } = props
    return (
      <Form className={`login-form ${className || ''}`} onSubmit={this.onSubmit}>
        { auth.get('loginError') && <div style={ { color: 'red' } }>{auth.get('loginError')}</div> }
        <Input placeholder="username" onChange={this.setUsername} />
        <Input placeholder="password" type="password" onChange={this.setPassword} />
        <Button variant="raised">Login</Button>
      </Form>
    )
  }
}

export default compose(connectRedux(
  (state) => pick(state, ['auth']),
  (dispatch) => bindActionCreators({ getAuthLogin: getAuthLoginAction }, dispatch),
))(LoginForm)
